import { Component, OnInit } from '@angular/core';
import { ColDef, ISetFilterParams } from 'ag-grid-enterprise';
import { CellRendererService } from 'src/app/common/ag-grid-table/cell-renderers/dynamic.cell-renderer'
import { UtilitiesService } from 'src/app/common/services/utilities.service';
import { AgGridToolsService } from 'src/app/common/ag-grid-table/services/ag-grid-tools.service';
import { BuildType } from 'src/app/enums/build-type';
import { getDefaultTableColumns } from 'src/app/common/ag-grid-table/default-table-columns';
import { TextCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/text/text.component';
import { BooleanEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/boolean/boolean.component';

@Component({
  selector: 'nuf-collection-entity-table-ag-grid',
  templateUrl: './nuf-collection-table-ag-grid.component.html',
  styleUrls: ['./nuf-collection-table-ag-grid.component.sass']
})
export class NufCollectionTableAgGridComponent implements OnInit {

  public entity: string = 'collections';
  public columnDefs: ColDef[] = [];
  public bulkUpdateColDefs: any[] = [];
  public columnSelection: string;
  public autopopulateSelect: string = '';
  public buildParams: any = {};
  public tableParams: any = {};

  private options: any = {};

  constructor(
    private cellRendererService: CellRendererService,
    private utilitiesService: UtilitiesService,
    private agGridToolsService: AgGridToolsService,
  ) {
    // this.autopopulateSelect = 'prefab_ref thumbnail_ref';
  }

  async ngOnInit(): Promise<void> {

    await this.setOptions();

    const defaultColumns = getDefaultTableColumns(this.entity, this.agGridToolsService);

    this.columnDefs = [
      ...defaultColumns,
      {
        headerName: 'Item Count',
        field: 'items_ref',
        sortable: true,
        unSortIcon: true,
        suppressSizeToFit: true,
        cellRenderer: TextCellRendererComponent,
        cellRendererParams: {
          entity: this.entity,
          isPill: true
        },
        valueGetter: (params: any) => {
          return params.data.items_ref ? params.data.items_ref.length : 0
        },
        resizable: true,

        width: 125,
      },
      {
        headerName: 'Bundle Asset',
        field: 'bundleAsset',
        cellRenderer: TextCellRendererComponent,
        valueGetter: (params: any) => {
          return params.data.bundleAsset ? 'Yes' : 'No'
        },
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: [true, false],
          valueFormatter: (params: any) => params.value ? 'Yes' : 'No'
        },
        floatingFilter: true,

      },
      {
        headerName: 'Bundle Image',
        field: 'bundleImage',
        cellRenderer: TextCellRendererComponent,
        valueGetter: (params: any) => {
          return params.data.bundleImage ? 'Yes' : 'No'
        },
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: [true, false],
          valueFormatter: (params: any) => params.value ? 'Yes' : 'No'
        },
        floatingFilter: true,

      },
      {
        headerName: 'Archived',
        field: 'archived',
        cellRenderer: TextCellRendererComponent,
        cellRendererParams: {
          onLabel: 'Archived',
          offLabel: 'Not Archived',
          isBoolean: true
        },
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: [true, false],
          valueFormatter: (params: any) => params.value ? 'Archived' : 'Not Archived'
        },
        floatingFilter: true,

        cellEditor: BooleanEditorComponent,
        type: 'editableColumn',
      },
      {
        headerName: 'Environment(s)',
        field: 'env',
        cellRenderer: TextCellRendererComponent,
        cellRendererParams: {
          entity: this.entity,
          isEnv: true
        },
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: ['dev', 'qa', 'prod']
        },
        floatingFilter: true,

      },
    ]

    this.bulkUpdateColDefs = [
      {
        name: 'Name', id: 'name', type: 'text'
      },
      {
        name: 'Start', id: 'start', type: 'date'
      },
      {
        name: 'End', id: 'end', type: 'date'
      },
      {
        name: 'Enabled', id: 'enabled', type: 'boolean', onLabel: 'Enabled', offLabel: 'Disabled'
      },
      {
        name: 'Environment(s)', id: 'env', type: 'multiselect', isFlatList: true
      },
    ];

    this.buildParams = {
      // imageKeys: ['thumbnail_ref'],
      // imageBuildType: BuildType.Images
    }

    this.tableParams = {
      customButtons: ['archived'],
      defaultQuery: {  "tags": { $in: 'NUF' }  }
    }

    this.columnSelection = this.agGridToolsService.getColumnFieldNamesFromCols(this.columnDefs);

  }

  async setOptions(){
  }

}
